import MiniCapture from "../MiniCapture";

const ComplianceSection = (props) => {
  const {
    mandatoryFieldRef,
    complianceCheck,
    handleComplianceToggle,
    isColdSeals,
    isFireKeepLocked,
    isGlazing,
    handleDeleteImages,
    resetCaptureFlag,
    isView,
    actionmenuFlag,
    actionImages,
    handleImagesChangeMini,
    handleResetAction,
    handleActionFieldsChange,
    isRequestForChange,
    isApprover,
    isAppprovalPending,
    handleApproverComments,
    handleApproverCheckbox,
    approverComments,
    approverCheckbox,
    isHoldOpenVisible,
  } = props;

  return (
    <div className="card-body">
      <div className="col-sm-12">
        <p className="fs-6 fw-semibold">Compliance Check</p>
      </div>
      <div className="col-sm-12">
        <ul className="complian_list">
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    id="intumescentStripsCheckbox"
                    name="intumescentStrips"
                    disabled={!isAppprovalPending}
                    checked={approverCheckbox?.intumescentStrips || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Are there intumescent strips?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.intumescentStrips
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  name="intumescentStrips"
                  checked={complianceCheck.intumescentStrips}
                  onClick={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>

          {actionmenuFlag.intumescentStrips && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.intumescentStrips
                  }
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"intumescentStrips"}
                  formData={complianceCheck}
                  savedImages={actionImages.intumescentStrips}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "intumescentStrips")
                  }
                  onResetChange={() =>
                    handleResetAction("intumescentStrips", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "intumescentStrips")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}

          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.intumescentStrips ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  disabled={!isAppprovalPending}
                  ref={(el) =>
                    (mandatoryFieldRef.current.intumescentStripsApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="intumescentStrips"
                  value={approverComments?.intumescentStrips}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}

          {isColdSeals && (
            <li>
              <div className="d-flex gap-2 align-items-center">
                {isRequestForChange && isApprover && (
                  <div className="form-floating d-flex justify-content-end pb-2">
                    <input
                      className="form-check-input form-check-input-checkbox custom-checkbox"
                      type="checkbox"
                      disabled={!isAppprovalPending}
                      id="coldSmokeSealsCheckbox"
                      name="coldSmokeSeals"
                      checked={approverCheckbox?.coldSmokeSeals || false}
                      onChange={(e) => handleApproverCheckbox(e)}
                    />
                  </div>
                )}
                <div className="">Are there cold smoke seals?</div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span style={{ fontSize: "13px" }}>N</span>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    disabled={
                      isApprover
                        ? isView
                        : isView && !approverCheckbox.coldSmokeSeals
                    }
                    id="flexSwitchCheckChecked"
                    checked={complianceCheck.coldSmokeSeals}
                    name="coldSmokeSeals"
                    onChange={handleComplianceToggle}
                  />
                </div>
                <span style={{ fontSize: "13px" }}>Y</span>
              </div>
            </li>
          )}
          {isColdSeals && actionmenuFlag.coldSmokeSeals && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.coldSmokeSeals
                  }
                  savedImages={actionImages.coldSmokeSeals}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"coldSmokeSeals"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "coldSmokeSeals")
                  }
                  onResetChange={() =>
                    handleResetAction("coldSmokeSeals", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "coldSmokeSeals")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isColdSeals && isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.coldSmokeSeals ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.coldSmokeSealsApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="coldSmokeSeals"
                  disabled={!isAppprovalPending}
                  value={approverComments?.coldSmokeSeals}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}

          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    disabled={!isAppprovalPending}
                    id="selfClosingDeviceCheckbox"
                    name="selfClosingDevice"
                    checked={approverCheckbox?.selfClosingDevice || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Self closing device?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.selfClosingDevice
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.selfClosingDevice}
                  name="selfClosingDevice"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.selfClosingDevice ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  disabled={!isAppprovalPending}
                  ref={(el) =>
                    (mandatoryFieldRef.current.selfClosingDeviceApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="selfClosingDevice"
                  value={approverComments?.selfClosingDevice}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          {isFireKeepLocked && (
            <li>
              <div className="d-flex gap-2 align-items-center">
                {isRequestForChange && isApprover && (
                  <div className="form-floating d-flex justify-content-end pb-2">
                    <input
                      className="form-check-input form-check-input-checkbox custom-checkbox"
                      type="checkbox"
                      disabled={!isAppprovalPending}
                      id="fireLockedSignCheckbox"
                      name="fireLockedSign"
                      checked={approverCheckbox?.fireLockedSign || false}
                      onChange={(e) => handleApproverCheckbox(e)}
                    />
                  </div>
                )}
                <div className="">Fire door Keep Locked sign?</div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span style={{ fontSize: "13px" }}>N</span>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    disabled={
                      isApprover
                        ? isView
                        : isView && !approverCheckbox.fireLockedSign
                    }
                    role="switch"
                    id="flexSwitchCheckChecked"
                    checked={complianceCheck.fireLockedSign}
                    name="fireLockedSign"
                    onChange={handleComplianceToggle}
                  />
                </div>
                <span style={{ fontSize: "13px" }}>Y</span>
              </div>
            </li>
          )}
          {actionmenuFlag.fireLockedSign && isFireKeepLocked && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.fireLockedSign
                  }
                  savedImages={actionImages.fireLockedSign}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"fireLockedSign"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "fireLockedSign")
                  }
                  onResetChange={() =>
                    handleResetAction("fireLockedSign", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "fireLockedSign")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isFireKeepLocked && isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.fireLockedSign ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.fireLockedSignApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  disabled={!isAppprovalPending}
                  name="fireLockedSign"
                  value={approverComments?.fireLockedSign}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    id="fireShutSignCheckbox"
                    disabled={!isAppprovalPending}
                    name="fireShutSign"
                    checked={approverCheckbox?.fireShutSign || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Fire door Keep Shut sign?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.fireShutSign
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.fireShutSign}
                  name="fireShutSign"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {actionmenuFlag.fireShutSign && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.fireShutSign
                  }
                  savedImages={actionImages.fireShutSign}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"fireShutSign"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "fireShutSign")
                  }
                  onResetChange={() =>
                    handleResetAction("fireShutSign", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "fireShutSign")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.fireShutSign ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.fireShutSignApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="fireShutSign"
                  disabled={!isAppprovalPending}
                  value={approverComments?.fireShutSign}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          {isHoldOpenVisible && (
            <li>
              <div className="d-flex gap-2 align-items-center">
                {isRequestForChange && isApprover && (
                  <div className="form-floating d-flex justify-content-end pb-2">
                    <input
                      className="form-check-input form-check-input-checkbox custom-checkbox"
                      type="checkbox"
                      disabled={!isAppprovalPending}
                      id="holdOpenDeviceCheckbox"
                      name="holdOpenDevice"
                      checked={approverCheckbox?.holdOpenDevice || false}
                      onChange={(e) => handleApproverCheckbox(e)}
                    />
                  </div>
                )}
                <div className="">Is there a hold open device?</div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span style={{ fontSize: "13px" }}>N</span>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    disabled={
                      isApprover
                        ? isView
                        : isView && !approverCheckbox.holdOpenDevice
                    }
                    role="switch"
                    id="flexSwitchCheckChecked"
                    checked={complianceCheck.holdOpenDevice}
                    name="holdOpenDevice"
                    onChange={handleComplianceToggle}
                  />
                </div>
                <span style={{ fontSize: "13px" }}>Y</span>
              </div>
            </li>
          )}
          {isHoldOpenVisible && isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.holdOpenDevice ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.holdOpenDeviceApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="holdOpenDevice"
                  disabled={!isAppprovalPending}
                  value={approverComments?.holdOpenDevice}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    id="visibleCertificationCheckbox"
                    name="visibleCertification"
                    disabled={!isAppprovalPending}
                    checked={approverCheckbox?.visibleCertification || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="" style={{ textAlign: "left" }}>
                Is certification visible on fire door?
              </div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.visibleCertification
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.visibleCertification}
                  name="visibleCertification"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.visibleCertification
                    ? {}
                    : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.visibleCertificationApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="visibleCertification"
                  disabled={!isAppprovalPending}
                  value={approverComments?.visibleCertification}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          {/* <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    id="doorGlazingCheckbox"
                    name="doorGlazing"
                    disabled={!isAppprovalPending}
                    checked={approverCheckbox?.doorGlazing || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Does the door contain glazing?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.doorGlazing
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.doorGlazing}
                  name="doorGlazing"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li> */}
          {/* {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={approverCheckbox?.doorGlazing ? {} : { display: "none" }}
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.doorGlazingApproverComments = el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="doorGlazing"
                  disabled={!isAppprovalPending}
                  value={approverComments?.doorGlazing}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )} */}
          {isGlazing && (
            <li>
              <div className="d-flex gap-2 align-items-center">
                {isRequestForChange && isApprover && (
                  <div className="form-floating d-flex justify-content-end pb-2">
                    <input
                      className="form-check-input form-check-input-checkbox custom-checkbox"
                      type="checkbox"
                      disabled={!isAppprovalPending}
                      id="pyroGlazingCheckbox"
                      name="pyroGlazing"
                      checked={approverCheckbox?.pyroGlazing || false}
                      onChange={(e) => handleApproverCheckbox(e)}
                    />
                  </div>
                )}
                <div className="">Is glazing pyro glazing?</div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span style={{ fontSize: "13px" }}>N</span>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    disabled={
                      isApprover
                        ? isView
                        : isView && !approverCheckbox.pyroGlazing
                    }
                    role="switch"
                    id="flexSwitchCheckChecked"
                    checked={complianceCheck.pyroGlazing}
                    name="pyroGlazing"
                    onChange={handleComplianceToggle}
                  />
                </div>
                <span style={{ fontSize: "13px" }}>Y</span>
              </div>
            </li>
          )}
          {actionmenuFlag.pyroGlazing && isGlazing && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.pyroGlazing
                  }
                  savedImages={actionImages.pyroGlazing}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"pyroGlazing"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "pyroGlazing")
                  }
                  onResetChange={() =>
                    handleResetAction("pyroGlazing", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "pyroGlazing")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isGlazing && isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={approverCheckbox?.pyroGlazing ? {} : { display: "none" }}
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.pyroGlazingApproverComments = el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="pyroGlazing"
                  disabled={!isAppprovalPending}
                  value={approverComments?.pyroGlazing}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    disabled={!isAppprovalPending}
                    id="doorCloseFullyCheckbox"
                    name="doorCloseFully"
                    checked={approverCheckbox?.doorCloseFully || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Does the door close fully?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.doorCloseFully
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.doorCloseFully}
                  name="doorCloseFully"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {actionmenuFlag.doorCloseFully && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.doorCloseFully
                  }
                  savedImages={actionImages.doorCloseFully}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"doorCloseFully"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "doorCloseFully")
                  }
                  onResetChange={() =>
                    handleResetAction("doorCloseFully", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "doorCloseFully")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.doorCloseFully ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.doorCloseFullyApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="doorCloseFully"
                  disabled={!isAppprovalPending}
                  value={approverComments?.doorCloseFully}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    disabled={!isAppprovalPending}
                    id="damageToDoorCheckbox"
                    name="damageToDoor"
                    checked={approverCheckbox?.damageToDoor || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Any damage to the door?<i
                className="bi bi-info-circle"
                style={{
                  fontSize: "0.9rem",
                  marginTop: "-7px",
                  marginLeft: "5px",
                }}
                title="This should include checking both the door latch and lock engagement to ensure they operate correctly."
              ></i></div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.damageToDoor
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.damageToDoor}
                  name="damageToDoor"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {actionmenuFlag.damageToDoor && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.damageToDoor
                  }
                  savedImages={actionImages.damageToDoor}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"damageToDoor"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "damageToDoor")
                  }
                  onResetChange={() =>
                    handleResetAction("damageToDoor", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "damageToDoor")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.damageToDoor ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.damageToDoorApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="damageToDoor"
                  disabled={!isAppprovalPending}
                  value={approverComments?.damageToDoor}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    disabled={!isAppprovalPending}
                    id="visualDefectsToDoorCheckbox"
                    name="visualDefectsToDoor"
                    checked={approverCheckbox?.visualDefectsToDoor || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Any visual defects on the door?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.visualDefectsToDoor
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.visualDefectsToDoor}
                  name="visualDefectsToDoor"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {actionmenuFlag.visualDefectsToDoor && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.visualDefectsToDoor
                  }
                  savedImages={actionImages.visualDefectsToDoor}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"visualDefectsToDoor"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "visualDefectsToDoor")
                  }
                  onResetChange={() =>
                    handleResetAction("visualDefectsToDoor", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "visualDefectsToDoor")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.visualDefectsToDoor
                    ? {}
                    : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.visualDefectsToDoorApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="visualDefectsToDoor"
                  disabled={!isAppprovalPending}
                  value={approverComments?.visualDefectsToDoor}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    disabled={!isAppprovalPending}
                    id="doorFitWithinFrameCheckbox"
                    name="doorFitWithinFrame"
                    checked={approverCheckbox?.doorFitWithinFrame || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="text-start">Does the door fit correctly within the frame?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.doorFitWithinFrame
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.doorFitWithinFrame}
                  name="doorFitWithinFrame"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {actionmenuFlag.doorFitWithinFrame && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.doorFitWithinFrame
                  }
                  savedImages={actionImages.doorFitWithinFrame}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"doorFitWithinFrame"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "doorFitWithinFrame")
                  }
                  onResetChange={() =>
                    handleResetAction("doorFitWithinFrame", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "doorFitWithinFrame")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.doorFitWithinFrame ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.doorFitWithinFrameApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="doorFitWithinFrame"
                  disabled={!isAppprovalPending}
                  value={approverComments?.doorFitWithinFrame}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    disabled={!isAppprovalPending}
                    id="damageToFrameCheckbox"
                    name="damageToFrame"
                    checked={approverCheckbox?.damageToFrame || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Any damage to the frame?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.damageToFrame
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.damageToFrame}
                  name="damageToFrame"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {actionmenuFlag.damageToFrame && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.damageToFrame
                  }
                  savedImages={actionImages.damageToFrame}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"damageToFrame"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "damageToFrame")
                  }
                  onResetChange={() =>
                    handleResetAction("damageToFrame", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "damageToFrame")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.damageToFrame ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.damageToFrameApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="damageToFrame"
                  disabled={!isAppprovalPending}
                  value={approverComments?.damageToFrame}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
          <li>
            <div className="d-flex gap-2 align-items-center">
              {isRequestForChange && isApprover && (
                <div className="form-floating d-flex justify-content-end pb-2">
                  <input
                    className="form-check-input form-check-input-checkbox custom-checkbox"
                    type="checkbox"
                    disabled={!isAppprovalPending}
                    id="hingesFireRatedCheckbox"
                    name="hingesFireRated"
                    checked={approverCheckbox?.hingesFireRated || false}
                    onChange={(e) => handleApproverCheckbox(e)}
                  />
                </div>
              )}
              <div className="">Are all hinges fire rated?</div>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span style={{ fontSize: "13px" }}>N</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  disabled={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.hingesFireRated
                  }
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked={complianceCheck.hingesFireRated}
                  name="hingesFireRated"
                  onChange={handleComplianceToggle}
                />
              </div>
              <span style={{ fontSize: "13px" }}>Y</span>
            </div>
          </li>
          {actionmenuFlag.hingesFireRated && (
            <li style={{ display: "block" }}>
              <div className="col-sm-12 mb-3 border p-2 rounded">
                <MiniCapture
                  isView={
                    isApprover
                      ? isView
                      : isView && !approverCheckbox.hingesFireRated
                  }
                  savedImages={actionImages.hingesFireRated}
                  mandatoryFieldRef={mandatoryFieldRef}
                  fieldValue={"hingesFireRated"}
                  formData={complianceCheck}
                  onImagesChange={(images) =>
                    handleImagesChangeMini(images, "hingesFireRated")
                  }
                  onResetChange={() =>
                    handleResetAction("hingesFireRated", "COMPLIANCE")
                  }
                  onHandleActionFieldsChange={(e, field) => {
                    handleActionFieldsChange(e, field, "COMPLIANCE");
                  }}
                  onImageDelete={(index) =>
                    handleDeleteImages(index, "hingesFireRated")
                  }
                  reset={resetCaptureFlag}
                />
              </div>
            </li>
          )}
          {/* {!actionmenuFlag.hingesFireRated && (
            <div className="form-floating flex-grow-1 pb-2">
              <select
                className="form-select"
                id="floatingSelect"
                name="hingesFireRated"
                disabled={isView}
                ref={(el) =>
                  (mandatoryFieldRef.current.hingesFireRatedRating = el)
                }
                aria-label="Floating label select example"
                value={complianceCheck.hingesFireRatedRating}
                onChange={(e) => {
                  handleActionFieldsChange(e, "Rating", "COMPLIANCE");
                }}
              >
                <option selected>Select</option>
                <option value="FD30">FD30</option>
                <option value="FD60">FD60</option>
                <option value="FD90">FD90</option>
                <option value="FD120">FD120</option>
                <option value="FD30S">FD30S</option>
                <option value="FD60S">FD60S</option>
                <option value="FD90S">FD90S</option>
                <option value="FD120S">FD120S</option>
              </select>
              <label htmlFor="floatingSelect">
                Hinge Fire Rating<span style={{ color: "red" }}>*</span>
              </label>
            </div>
          )} */}
          {isRequestForChange && (
            <li style={{ display: "block" }}>
              <div
                className="form-floating mb-1"
                style={
                  approverCheckbox?.hingesFireRated ? {} : { display: "none" }
                }
              >
                <input
                  type="text"
                  ref={(el) =>
                    (mandatoryFieldRef.current.hingesFireRatedApproverComments =
                      el)
                  }
                  className="form-control"
                  id="floatingInputValue"
                  name="hingesFireRated"
                  disabled={!isAppprovalPending}
                  value={approverComments?.hingesFireRated}
                  onChange={(e) => {
                    handleApproverComments(e);
                  }}
                />
                <label htmlFor="floatingInputValue">
                  Approver Comments
                  <span style={{ color: "red" }}>*</span>
                </label>
              </div>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ComplianceSection;
